module.exports = __webpack_public_path__ + "static/media/10_negro.b9b0da2c.svg";